import { useEffect, useState } from "react";
import { DomShell } from "./_gameKit";
import AdReward from "./_adReward";

const ROWS = 4, COLS = 4;

function empty() { return Array.from({ length: ROWS }, () => Array(COLS).fill(0)); }
function dropInto(board, col, who) {
  for (let r = ROWS - 1; r >= 0; r--) {
    if (board[r][col] === 0) { board[r][col] = who; return r; }
  }
  return -1;
}
function checkWin(board) {
  const dirs = [[0, 1], [1, 0], [1, 1], [1, -1]];
  for (let r = 0; r < ROWS; r++) for (let c = 0; c < COLS; c++) {
    const p = board[r][c]; if (!p) continue;
    for (const [dr, dc] of dirs) {
      let k = 0;
      for (let i = 0; i < 4; i++) {
        const nr = r + dr * i, nc = c + dc * i;
        if (nr < 0 || nr >= ROWS || nc < 0 || nc >= COLS || board[nr][nc] !== p) break;
        k++;
      }
      if (k === 4) return p;
    }
  }
  if (board.every((row) => row.every((v) => v))) return "draw";
  return null;
}

export default function JixxeoConnect4() {
  const [board, setBoard] = useState(empty());
  const [turn, setTurn] = useState(1);
  const [status, setStatus] = useState(null);
  const [score, setScore] = useState({ you: 0, ai: 0 });

  const play = (col) => {
    if (turn !== 1 || status) return;
    const nb = board.map((r) => [...r]);
    if (dropInto(nb, col, 1) === -1) return;
    setBoard(nb);
    const w = checkWin(nb);
    if (w) { setStatus(w); if (w === 1) setScore((s) => ({ ...s, you: s.you + 1 })); return; }
    setTurn(2);
  };

  useEffect(() => {
    if (turn !== 2 || status) return;
    const t = setTimeout(() => {
      const nb = board.map((r) => [...r]);
      // Simple AI: prefer center, block wins, take wins
      const canPlay = [...Array(COLS).keys()].filter((c) => nb[0][c] === 0);
      // 1. take win
      for (const c of canPlay) { const test = nb.map((r) => [...r]); dropInto(test, c, 2); if (checkWin(test) === 2) { dropInto(nb, c, 2); return finish(nb); } }
      // 2. block
      for (const c of canPlay) { const test = nb.map((r) => [...r]); dropInto(test, c, 1); if (checkWin(test) === 1) { dropInto(nb, c, 2); return finish(nb); } }
      // 3. center preference then random
      const order = canPlay.sort((a, b) => Math.abs(a - 1.5) - Math.abs(b - 1.5));
      dropInto(nb, order[0], 2);
      finish(nb);
    }, 500);
    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [turn, status]);

  const finish = (nb) => {
    setBoard(nb);
    const w = checkWin(nb);
    if (w) { setStatus(w); if (w === 2) setScore((s) => ({ ...s, ai: s.ai + 1 })); return; }
    setTurn(1);
  };

  const restart = () => { setBoard(empty()); setTurn(1); setStatus(null); };

  return (
    <DomShell title="Jixxeo Connect 4 Mini" accent="#39FF14"
      chips={[["You", score.you], ["AI", score.ai], ["Turn", turn === 1 ? "Yours" : "AI…"]]}
      instructions="Tap a column · connect 4 to win"
    >
      <div className="grid grid-cols-4 gap-1 max-w-xs mx-auto">
        {board.map((row, r) => row.map((v, c) => (
          <button key={`${r}-${c}`}
            onClick={() => play(c)}
            disabled={turn !== 1 || !!status}
            className="aspect-square rounded-full border-2 flex items-center justify-center transition-colors"
            style={{
              background: v === 1 ? "#00F0FF" : v === 2 ? "#FF003C" : "rgba(255,255,255,0.04)",
              borderColor: v === 1 ? "#00F0FF" : v === 2 ? "#FF003C" : "rgba(255,255,255,0.1)",
              boxShadow: v ? `0 0 12px ${v === 1 ? "#00F0FF" : "#FF003C"}` : "none",
            }}
          />
        )))}
      </div>
      {status && (
        <div className="text-center mt-4 space-y-3">
          <div className="font-heading font-black text-2xl uppercase tracking-tighter"
            style={{ color: status === 1 ? "#00F0FF" : status === 2 ? "#FF003C" : "#FFE300" }}>
            {status === 1 ? "You win ⚡" : status === 2 ? "AI wins" : "Draw"}
          </div>
          <div className="flex justify-center"><AdReward game="jixxeo-connect4-mini" compact /></div>
          <button onClick={restart} className="mono text-[10px] uppercase tracking-widest bg-white/10 hover:bg-white/20 text-white font-black px-5 py-2 rounded-full">
            Play again
          </button>
        </div>
      )}
    </DomShell>
  );
}
